import React, { FunctionComponent } from "react";

import { useLanguage } from "../../i18n/useLanguage";
import { useNullableDealerAccountInfo } from "../../stores/hooks/useNullableDealerAccountInfo";

export const LegalFooter: FunctionComponent = () => {
  const [language] = useLanguage();
  const dealerInfo = useNullableDealerAccountInfo();
  const legalFooter = dealerInfo?.legalFooter?.[language];

  if (!legalFooter) return null;

  return (
    <footer className="tw-legal-footer">
      <div className="tw-legal-footer__content">{legalFooter}</div>
    </footer>
  );
};
